// Copyright (c) 2017 Deere & Company

import ClaimSearch from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import reports from '../../routes/claims/reports';

const getStateToBindToContainerProps = state => ({
    ...state.claims.claimSearch,
    allClaimsCount: state.claims.allClaims.allClaims.length,
    dealerInvoiceCount: state.claims.dealerInvoices.dealerInvoices.length,
    exportToExcel: state.exportToExcel,
    reportsRoutes: reports(state),
    searchByDropDown: state.claims.searchDropDown,
    searchQueryString: state.claims.searchQueryString,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {location, routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams: location.query,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimSearch);



// WEBPACK FOOTER //
// ./src/claim/claim-search/state-connector.js